import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import CookieUtil from '../../utils/cookieUtil';
import { fetchSchedules } from '../../api/scheduleApi';
import { setScheduleFilter } from '../../store/Actions/HomePage';
import LandingPageTabs from './landingPageTabs';
import LandingPageSchedules from './landingPageSchedules';
import Loader from '../common/Loader';
import { highlightTitle } from '../../utils/htmlHelper';
import { getImage, getVideo } from '../../utils/helper';
import { colors } from 'react-select/dist/declarations/src/theme';

interface AboutProps {
    landingPageData: any; 
    label: string;
          
  }
 
const ConferenceSchedule:React.FC <AboutProps> = ({landingPageData,label}) => {
  const dispatch = useDispatch();

  const eventData = useSelector((state: any) => state.eventData, shallowEqual);
  console.log(eventData)
  const eventId = useMemo(() => eventData._id, [eventData._id]);
  const [isUserLogedIn, setIsUserLogedIn] = useState<boolean>(
    !!CookieUtil.getCookie('user_info')
  );

  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!eventData?._id) return;

    let isMounted = true;

    const loadSchedules = async () => {
      try {
        setLoading(true);
        const data: any = await fetchSchedules(eventData._id, dispatch);
        if (isMounted) setSchedules(data);
        if (data.length > 0) dispatch(setScheduleFilter(data[0]));
      } catch (error) {
        console.error('Error fetching schedules:', error);
      } finally {
        setLoading(false);
      }
    };

    loadSchedules();

    return () => {
      isMounted = false;
    };
  }, [eventData._id]);

  const text = landingPageData?.conference_text || '';
  const eventTitle = eventData?.title || '';
  const themePrimaryColor = eventData.primary_color;

 



  if (loading) {
    return <Loader/>
  }
  
  if (!schedules || schedules.length === 0) {
    return null;
  }

   const image = eventData.background_picture;

 const bgImage = eventData.background_picture
    ? {
        backgroundImage: `url(${getImage(image)})`,        
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize:'cover',
        color:'#ffffff',
      }
    : {
      backgroundColor:'#ffffff',
      color:'#000000',
    };



  return (
    <>
      {/* Conference schedule section */}
      <div className="single-section schedule-area" style={bgImage} id="schedule">
        <div className='schedule_drop'></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-heading">
                <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>
                <p className="section-description col-lg-8 col-md-10 col-sm-12">
                  {highlightTitle(text, eventTitle, themePrimaryColor)}


                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* Tabs */}
              <LandingPageTabs schedules={schedules} />
              {/* Tab content */}
              <LandingPageSchedules />
            </div>
          </div>
        </div>
      </div>

     
    </>
  );
};

export default ConferenceSchedule;
